// extracted by mini-css-extract-plugin
export var donorShoutout = "donor-shoutout-module--donorShoutout--bppO1";
export var logoImage = "donor-shoutout-module--logoImage--J66q7";
export var text = "donor-shoutout-module--text--qhAtv";